export const environment = {
    api: process.env.VUE_APP_API,
    apiTracking: process.env.VUE_APP_API_TRACKING,
    apiLeads: process.env.VUE_APP_IS_API_LEADS,
    isApi: process.env.VUE_APP_IS_API,
    culquiToken: process.env.VUE_APP_CULQUI_TOKEN,
    isApiAuth: process.env.VUE_APP_IS_API_AUTH,
    isApiClient: process.env.VUE_APP_IS_API_CLIENT,
    isApiPlans: process.env.VUE_APP_IS_APLI_PLANS,
    isApiQuote: process.env.VUE_APP_IS_APLI_QUOTE,
    isApiEmission: process.env.VUE_APP_IS_APLI_EMISSION,
    isApiTermConditions: process.env.VUE_APP_IS_TERM_CONDITIONS,
    isApiCancel: process.env.VUE_APP_IS_APLI_CANCEL,
    brazeApi: process.env.VUE_APP_BRAZE_API,
    brazeToken: process.env.VUE_APP_BRAZE_BEARER,
    isTokenApiClientMasked: process.env.VUE_APP_IS_TOKEN_API_CLIENT_MASKED,
    isApiClientMasked: process.env.VUE_APP_IS_API_CLIENT_MASKED,
    apiVida: process.env.VUE_APP_IS_API_VIDA,
    apiGatewayUrl: process.env.VUE_APP_IS_GATEWAY_URL,
    apiGatewaySaveClient: process.env.VUE_APP_IS_GATEWAY_SAVE_CLIENT,
    apiGatewayTracking: process.env.VUE_APP_IS_GATEWAY_ID_TRACKING,
    apiGatewayBraze: process.env.VUE_APP_IS_GATEWAY_ID_BRAZE,
    apiGatewayEmission: process.env.VUE_APP_IS_GATEWAY_ID_EMISSION,
    apiGatewayAnalytics: process.env.VUE_APP_IS_GATEWAY_ID_ANALYTICS,
    apiCulqiToken: process.env.VUE_APP_IS_CULQI_TOKEN,
};